import EmailPulseSummaryCards from '../email-pulse-summary-cards/email-pulse-summary-cards.component';
import { ordersSummaryCardsConfig } from './orders.config';

/**
 * Orders tab summary cards component.
 * Wrapper around the generic EmailPulseSummaryCards with Orders-specific configuration.
 */
const OrdersSummaryCards = () => {
  return <EmailPulseSummaryCards config={ordersSummaryCardsConfig} />;
};

export default OrdersSummaryCards;
